import { useEffect, useRef } from "react";

export const useEffectAfterMount = (callBackFn: () => (() => void) | void, dependencies: unknown[] = []) => {
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }

    return callBackFn();
  }, dependencies);
};
